import { render, staticRenderFns } from "./add-audio-modal.vue?vue&type=template&id=3e0e06e6&scoped=true"
import script from "./add-audio-modal.vue?vue&type=script&lang=ts"
export * from "./add-audio-modal.vue?vue&type=script&lang=ts"
import style0 from "./add-audio-modal.vue?vue&type=style&index=0&id=3e0e06e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e06e6",
  null
  
)

export default component.exports